/**
 * Skald visitor ID (stats.wisernotify.com analytics).
 *
 * skald.js on wisernotify.com keeps an anonymous ID in the `skald_vid` cookie,
 * shared with every *.wisernotify.com subdomain. Sending it with sign-up lets
 * backend_service (config/skald.js) join the new account to the website
 * journey that led to it. Never sent when the cookie is missing or malformed.
 */

const VISITOR_ID = /^skv_[A-Za-z0-9_-]{22}$/;

export function skaldVisitorId() {
  try {
    const match = document.cookie.match(/(?:^|;\s*)skald_vid=([^;]+)/);
    const id = match ? decodeURIComponent(match[1]) : '';
    return VISITOR_ID.test(id) ? id : '';
  } catch (e) {
    return '';
  }
}

/** The sign-up payload with `skv` added when this browser has a visitor ID. */
export function withSkaldId(payload) {
  const skv = skaldVisitorId();
  return skv && payload && typeof payload === 'object' ? { ...payload, skv } : payload;
}
